export default __webpack_public_path__ + "static/media/Snd_ClowerP.81d19fed.mp3";